import React, { Component } from 'react';
import { Button, Select, DatePicker,Modal, Row, Col, Input, Radio, message,Tooltip ,Icon,AutoComplete } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import format from '../../shared/format';
import TableC from '../../basicElement/TableC';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import moment from 'moment';
import SearchInput from '../../common/SearchInput';
import SearchMulSelect from '../../common/SearchMulSelect';

const yearFormat = 'YYYY';
let year = moment().format(yearFormat);

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;
const TextArea = Input.TextArea;

class Filter extends Component {
    state = {
        searchParams: { ...this.props.params },
        userOptions: [],
        leaderOptions:[],
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params != this.props.params) {
            this.setState({ searchParams: { ...nextProps.params }});
        }
    }

    search = () => {
        const { searchParams } = this.state;
        const params = {
            ...searchParams,
        };
        this.props.search(params);
    }

    export = () => {
        const { searchParams } = this.state;
        const params = {
            ...searchParams,
        };
        this.props.export(params);
    }

    onChange = (searchParams) => {
        this.setState({ searchParams: { ...searchParams }});
    }
    
    handleSelectChange = (value, key) => {
        let { searchParams } = this.state;
        searchParams[key] = value;
        this.onChange(searchParams);
    }

    handleChange = (value, key) => {
        let { searchParams } = this.state;
        const { value: id, text: name } = value;
        switch (key) {
            case 'investigation': 
            {
                searchParams[`searchInvId`] = id;
                searchParams[`${key}Name`] = name;
                this.onChange(searchParams);
                break;
            }
            case 'identifyCode':
            {
                searchParams[`${key}Id`] = id;
                searchParams[`investigationIdentifyCode`] = name;
                this.onChange(searchParams);
                break;
            }
            case 'user':
            {
                searchParams[`searchUserId`] = id;
                searchParams[`userName`] = name;
                this.onChange(searchParams);
                break;
            }
            case 'leader':
            {
                searchParams[`searchLeaderUserId`] = id;
                searchParams[`leaderName`] = name;
                this.onChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                this.onChange(searchParams);
        }
    }

    render() {
        const { 
            searchParams,
        } = this.state;
        const { 
            recordMonth, 
            investigationName,
            leaderName,
            userName,
        } = searchParams;
        return (
            <div className="filter-wrap" style={{ padding: 10, background: '#fff' }}>
            <div className="filter-item">
                <label className="filter-label">统计时间</label>
                <MonthPicker
                    format={monthFormat}
                    value={recordMonth ? moment(recordMonth) : null}
                    onChange={(date, dateString) => this.handleSelectChange( dateString, 'recordMonth')}
                    allowClear={false}
                    style={{width: 100, verticalAlign: 'middle'}}
                />
            </div>
            <div className="filter-item">
                <label className="filter-label">员工</label>
                <SearchRetrieve
                    keyword='keyword'
                    style={{ width: 150 }}
                    placeholder="输入工号或姓名检索"
                    url={API_URL.investigation.queryUserByKey}
                    value={userName}
                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                    onChange={(option) => this.handleChange(option, 'user')}
                />
            </div>
            <div className="filter-item">
                <label className="filter-label">直线主管</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 150 }}
                        placeholder="输入工号或姓名检索"
                        url={API_URL.team.userlist}
                        value={leaderName}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={(option) => this.handleChange(option, 'leader')}
                    />
            </div>
            <div className="filter-item">
                <label className="filter-label">项目简称</label>
                <SearchRetrieve
                    keyword="investigationName"
                    style={{ width: 160 }}
                    placeholder="输入名称检索"
                    params={{ limit: 20 }}
                    value={investigationName}
                    url={API_URL.investigation.queryInvestigationByName}
                    config={{ id: "investigationId", name: "investigationName" }}
                    onChange={value => this.handleChange(value, 'investigation')}
                />
            </div>
            <div className="filter-item">
                <label className="filter-label">项目识别码</label>
                <SearchRetrieve
                    keyword='identifyCode'
                    style={{ width: 120 }}
                    placeholder="输入名称检索"
                    value={searchParams.investigationIdentifyCode}
                    params={{ limit: 20 }}
                    url={API_URL.contract.queryInvIdentifyCodeList}
                    config={{ id: 'investigationIdentifyCodeId', name: 'identifyCode' }}
                    onChange={(option) => this.handleChange(option, 'identifyCode')}
                />
            </div>
            <div className="filter-item">
                <label htmlFor="" className="filter-label">状态</label>
                <Select
                    onChange={value => this.handleSelectChange(value, 'workStatus')}
                    placeholder="请选择"
                    value={searchParams.workStatus}
                    style={{ width: 100 }}
                    allowClear={true}
                >
                    <Option value="WORKING">在职</Option>
                    <Option value="LEFT">离职</Option>
                </Select>
            </div>
            <div className="filter-item">
                <label htmlFor="" className="filter-label">项目状态</label>
                <Select
                    onChange={value => this.handleSelectChange(value, 'roleStatus')}
                    placeholder="请选择"
                    value={searchParams.roleStatus}
                    style={{ width: 100 }}
                    allowClear={true}
                >
                    <Option value="ACTIVE">现任</Option>
                    <Option value="INACTIVE">前任</Option>
                    <Option value="LEFT">离职</Option>
                </Select>
            </div>
            <div className="filter-item">
                <Button type="primary" onClick={this.search}>搜索</Button>
            </div>
            <div className="filter-item">
            <Button type="primary" onClick={this.export}>导出</Button>
            </div>
        </div>
        )
    }
}

class InvPrincipal extends Component {
    state = {
        data: [],
        loading: false,
        sortParams: {},
        searchParams: { 
            recordMonth: null,
        },
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.getDate()
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.home.queryInvestigationLeaderRecord,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            this.setState({
            searchParams:{
                recordMonth: moment(date).add(-1, 'M').format('YYYY-MM')
            }
        },()=>{
            this.loadData();
        });
        })
    }

    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination, searchParams: {...params} }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const url = API_URL.home.exportInvestigationLeaderRecord;
        ExportUtil.export({ ...sortParams, ...searchParams}, null, url);
        message.success('项目负责人记录开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出')
    }

    getColumns = () => {
        const columns = [{
            title: '员工姓名',
            dataIndex: 'userName',
            key: 'userName',
            fixed: 'left',
            width: 80,
        },{
            title: '员工工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed: 'left',
            width: 80,
        },{
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
            width: 80,
        },{
            title: '主管姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 80,
        },{
            title: '主管工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            width: 80,
        },{
            title: '状态',
            dataIndex: 'workStatus',
            key: 'workStatus',
            width: 60,
            render: text => text === 'WORKING' ? '在职' : '离职 '
        },{
            title: '项目识别码',
            dataIndex: 'identifyCode',
            key: 'identifyCode',
            width: 120,
        },{
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        },{
            title: '项目角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            width: 80,
            render: text => text == 'TAL' ? '领域leader' : text
        },{
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 100,
        },{
            title: '项目阶段',
            dataIndex: 'stageValues',
            key: 'stageValues',
            width: 100,
        },{
            title: '是否是大项目经理',
            dataIndex: 'isMain',
            key: 'isMain',
            width: 100,
            render: ( test, record ) => {
                const { roleCode, isMain } = record;
                return roleCode == 'PM' ? isMain == '1' ? '是' : '否' : '-'
            }
        },{
            title: '是否是主领域leader',
            dataIndex: 'isMainleader',
            key: 'isMainleader',
            width: 100,
            render: ( test, record ) => {
                const { roleCode, isMain } = record;
                return roleCode == 'TAL' ? isMain == '1' ? '是' : '否' : '-'
            }
        },{
            title: '项目状态',
            dataIndex: 'roleStatus',
            key: 'roleStatus',
            width: 100,
            render: text => (text == 'ACTIVE' || text =='ACTIVCE') ? '现任' : text == 'INACTIVE' ? '前任' : '离职'
        },{
            title: '变更日期',
            dataIndex: 'changeDate',
            key: 'changeDate',
            width: 100,
        }];
        return columns
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams } = this.state;
        return (
            <div className="FinancialAnomalyReportContent">
                <div className='modTitle'>项目负责人</div>
                <Filter
                    params={searchParams}
                    search={this.search}
                    export={this.export}
                />
                <TableC
                    data={data}
                    loading={loading}
                    className="FinancialAnomalyReport"
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default InvPrincipal;


// WEBPACK FOOTER //
// ./src/components/homePage/myFocus/InvPrincipal.js